import React, { useEffect, useState, useCallback } from 'react'
import { Rose } from '@ow/charts/lib'
import { useParams } from 'react-router-dom'
import { getApiVersion, http } from '@vt/apis/lib-ex'
import { cloneDeep } from 'lodash-es'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import NullData from './nullData'
import close from '../assets/close.png'
import List from './list'

const StyledModal = styled.div`
  width: 490px;
  height: 300px;
  background: rgba(15, 21, 36, 0.9);
  border: 1px solid #389ef2;
  box-shadow: inset 0 1px 20px 0 rgba(56, 158, 242, 0.5);
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  ${tw`p-4 flex flex-col gap-2`}
  .modaltitle {
    background-image: linear-gradient(to bottom, #fff 0%, #9cd2ff 100%);
    background-clip: text;
    font-family: PingFangSC-S0pxibold;
    font-weight: 600;
    font-size: 16px;
  }
`
const Pie = function ({ data, customDsl }) {
  const { appId } = useParams()
  const [itemData, setItemData] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [currentName, setCurrentName] = useState()

  useEffect(() => {
    let newDsl = data.dsl
    const _dsl = cloneDeep(customDsl)
    if (_dsl) {
      if (Object.keys(data.dsl).length !== 0) {
        _dsl.childQueries.push(data.dsl)
      }
      newDsl = _dsl
    }
    http()
      .post(`${getApiVersion()}/apps/${appId}/${data.fetch}`, { ...newDsl })
      .json()
      .then((res) => {
        setItemData(res)
      })
  }, [customDsl])

  const clickPie = useCallback((params) => {
    console.log('pppp----', params)
    setCurrentName(params.name)
    if (data.modal) {
      setOpenModal(true)
    }
  }, [])

  return (
    <div className="h-full w-full">
      {itemData.length === 0 && <NullData />}
      {itemData.length !== 0 && (
        <Rose
          colors={[
            '#2F91BF',
            '#6B84B7',
            '#5664A1',
            '#57C1C5',
            '#3688BF',
            '#3669AB',
            '#465C98',
            '#18799C',
            '#47B5B4',
            '#3965AE',
          ]}
          id="pie"
          width="100%"
          height="100%"
          data={itemData}
          showLabel={false}
          radius={['40%', '85%']}
          legend={{
            orient: 'vertical',
            right: 10,
            top: 20,
            textStyle: {
              color: '#fff',
              fontSize: 12,
            },
            itemWidth: 6,
            itemHeight: 6,
            icon: 'circle',
            type: 'scroll',
          }}
          label={{
            show: true,
            fontSize: 14,
            fontWeight: 'bold',
            color: '#fff',
            position: 'inside',
            formatter: (v) => {
              return v.data.value
            },
          }}
          right={80}
          onClick={clickPie}
        />
      )}
      {openModal && (
        <StyledModal>
          <div className="flex justify-between items-center">
            <div className="modaltitle">{data.modal.title}</div>
            <div
              className="cursor-pointer"
              onClick={() => {
                setOpenModal(false)
              }}
            >
              <img
                src={close}
                alt="close"
                style={{ width: '20px', height: '20px' }}
              />
            </div>
          </div>
          <List data={data.modal} customDsl={customDsl} filter={currentName} />
        </StyledModal>
      )}
    </div>
  )
}

export default Pie
